import React from 'react';
import './App.css';
import Header from './dashboard/header';
import Bodyhead from './dashboard/bodyhead';
import 'font-awesome/css/font-awesome.min.css';
import {
  HashRouter,
  Switch,
  Route,
  Link
} from "react-router-dom";
import { alpha } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import { useTheme } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import InputBase from '@mui/material/InputBase';
import Badge from '@mui/material/Badge';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import AccountCircle from '@mui/icons-material/AccountCircle';
import MailIcon from '@mui/icons-material/Mail';
import NotificationsIcon from '@mui/icons-material/Notifications';
import MoreIcon from '@mui/icons-material/MoreVert';
//import Link from '@material-ui/core/Link';
import Home from './page/home';
import About from './page/about';
import GenericNotFound from './page/notfound';
import { createBrowserHistory } from 'history';
import Login from './login/login';
import Register from './register/register';

const useStyles = makeStyles(theme => ({
  root: {
    '& > * + *': {
      marginLeft: useTheme().spacing(2),
    },
    color: 'white',
  },
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: useTheme().spacing(2),
  },
  title: {
    display: 'none',
    [useTheme().breakpoints.up('sm')]: {
      display: 'block',
    },
  },
  search: {
    position: 'relative',
    borderRadius: useTheme().shape.borderRadius,
    backgroundColor: alpha(useTheme().palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: alpha(useTheme().palette.common.white, 0.25),
    },
    marginRight: useTheme().spacing(2),
    marginLeft: 0,
    width: '100%',
    [useTheme().breakpoints.up('sm')]: {
      marginLeft: useTheme().spacing(3),
      width: 'auto',
    },
  },
  searchIcon: {
    width: useTheme().spacing(7),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    padding: useTheme().spacing(1, 1, 1, 7),
    transition: useTheme().transitions.create('width'),
    width: '100%',
    [useTheme().breakpoints.up('md')]: {
      width: 200,
    },
  },
  sectionDesktop: {
    display: 'none',
    [useTheme().breakpoints.up('md')]: {
      display: 'flex',
    },
  },
  sectionMobile: {
    display: 'flex',
    [useTheme().breakpoints.up('md')]: {
      display: 'none',
    },
  },
}));

function App() {
  if(localStorage.getItem('authlogin') == null){
  localStorage.setItem('authlogin', 'false');
  }
  //alert(localStorage.getItem('authlogin'));
  const classes = useStyles();
  //const basepath = (process.env.PUBLIC_URL === '.') ?
  //undefined :
  //process.env.PUBLIC_URL.substr(`${window.location.protocol}//${window.location.host}`.length);
  //const urlpath = '/reactadmin/build';
  //const history = createBrowserHistory({ basepath });
  
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);

  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const handleProfileMenuOpen = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = event => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const home = () => {
    //window.location.assign(urlpath+"/");
  }

  const about = () => {
    //window.location.assign(urlpath+"/about");
  }

  const dashboard = () => {
    //window.location.assign(urlpath+"/dashboard");
  }

  const history = createBrowserHistory();
  const menuId = 'primary-search-account-menu';
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={handleMenuClose}>Profile</MenuItem>
      <MenuItem onClick={handleMenuClose}>My account</MenuItem>
    </Menu>
  );

  const mobileMenuId = 'primary-search-account-menu-mobile';
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem>
      <HashRouter basename="/"><i className="fa fa-home"></i><Link to={"/"} color="inherit" onClick={home}>&nbsp;&nbsp;Home</Link></HashRouter>
      </MenuItem>
      <MenuItem>
      <HashRouter basename="/"><i className="fa fa-briefcase"></i><Link to={"/about"} color="inherit" onClick={about}>&nbsp;&nbsp;About</Link></HashRouter>
      </MenuItem>
      <MenuItem>
      <HashRouter basename="/"><i className="fa fa-tachometer"></i><Link to={"/dashboard"} color="inherit" onClick={dashboard}>&nbsp;&nbsp;Dashboard</Link></HashRouter>
      </MenuItem>
      {localStorage.getItem('authlogin')==='false' && (<HashRouter basename="/"><MenuItem><i className="fa fa-sign-out"></i><Link to={"/login"} color="inherit">Login</Link></MenuItem></HashRouter>)}
      {localStorage.getItem('authlogin')==='false' && (<HashRouter basename="/"><MenuItem><i className="fa fa-sign-out"></i><Link to={"/register"} color="inherit">Register</Link></MenuItem></HashRouter>)}
      {localStorage.getItem('authlogin')==='true' && (<HashRouter basename="/"><MenuItem><i className="fa fa-sign-in"></i><Link to={"/logout"} color="inherit">Logout</Link></MenuItem></HashRouter>)}
      {localStorage.getItem('authlogin')==='true' && (<MenuItem>
        <IconButton aria-label="show 4 new mails" color="inherit">
          <Badge badgeContent={4} color="secondary">
            <MailIcon />
          </Badge>
        </IconButton>
        <p>Messages</p>
      </MenuItem>)}
      {localStorage.getItem('authlogin')==='true' && (<MenuItem>
        <IconButton aria-label="show 11 new notifications" color="inherit">
          <Badge badgeContent={11} color="secondary">
            <NotificationsIcon />
          </Badge>
        </IconButton>
        <p>Notifications</p>
      </MenuItem>)}
      {localStorage.getItem('authlogin')==='true' && (<MenuItem onClick={handleProfileMenuOpen}>
        <IconButton
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <AccountCircle />
        </IconButton>
        <p>Profile</p>
      </MenuItem>)}
    </Menu>
  );

  return (
    <div className="App">
      <div className={classes.grow}>
      <AppBar position="static">
        <Toolbar>
          <IconButton
            edge="start"
            className={classes.menuButton}
            color="inherit"
            aria-label="open drawer"
          >
            <MenuIcon />
          </IconButton>
          <Typography className={classes.title} variant="h6" noWrap>
            React Sopcast
          </Typography>
          <div className={classes.search}>
            <div className={classes.searchIcon}>
              <SearchIcon />
            </div>
            <InputBase
              placeholder="Search…"
              classes={{
                root: classes.inputRoot,
                input: classes.inputInput,
              }}
              inputProps={{ 'aria-label': 'search' }}
            />  
          </div>

          <div className={classes.grow} >
          <div className={classes.sectionDesktop}>
          <Typography className={classes.root}>
          <HashRouter basename="/">
          <Link to={"/"} color="inherit" onClick={home}>Home</Link>
          <Link to={"/about"} color="inherit" onClick={about}>About</Link>
          <Link to={"/dashboard"} color="inherit" onClick={dashboard}>Dashboard</Link>
          {localStorage.getItem('authlogin')==='false' && (<Link to={"/login"} color="inherit">Login</Link>)}
          {localStorage.getItem('authlogin')==='false' && (<Link to={"/register"} color="inherit">Register</Link>)}
          {localStorage.getItem('authlogin')==='true' && (<Link to={"/logout"} color="inherit">Logout</Link>)}
          </HashRouter>
          </Typography>
          </div>
          </div>

          <div className={classes.grow} />
          <div className={classes.sectionDesktop}>
          {localStorage.getItem('authlogin')==='false' && (<HashRouter basename="/"><MenuItem><i className="fa fa-sign-out"></i><Link to={"/login"} color="inherit">Login</Link></MenuItem></HashRouter>)}
          {localStorage.getItem('authlogin')==='true' && (<HashRouter basename="/"><MenuItem><i className="fa fa-sign-in"></i><Link to={"/logout"} color="inherit">Logout</Link></MenuItem></HashRouter>)}
          {localStorage.getItem('authlogin')==='true' && (<IconButton aria-label="show 4 new mails" color="inherit">
              <Badge badgeContent={4} color="secondary">
                <MailIcon />
              </Badge>
            </IconButton>)}
            {localStorage.getItem('authlogin')==='true' && (<IconButton aria-label="show 17 new notifications" color="inherit">
              <Badge badgeContent={17} color="secondary">
                <NotificationsIcon />
              </Badge>
            </IconButton>)}
            {localStorage.getItem('authlogin')==='true' && (<IconButton
              edge="end"
              aria-label="account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
              color="inherit"
            >
              <AccountCircle />
            </IconButton>)}
          </div>
          <div className={classes.sectionMobile}>
            <IconButton
              aria-label="show more"
              aria-controls={mobileMenuId}
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
              color="inherit"
            >
              <MoreIcon />
            </IconButton>
          </div>
        </Toolbar>
      </AppBar>
      {renderMobileMenu}
      {renderMenu}
    </div>
      <HashRouter basename="/" >
      <div>

        {/*
          A <Switch> looks through all its children <Route>
          elements and renders the first one whose path
          matches the current URL. Use a <Switch> any time
          you have multiple routes, but you want only one
          of them to render at a time
        */}
        <Switch>
          <Route exact path={"/"} component={ Home } ></Route>
          <Route exact path={"/login"} component={ Login } ></Route>
          <Route exact path={"/register"} component={ Register } ></Route>
          <Route exact path={"/logout"} component={ Logout } ></Route>
          <Route exact path={"/about"} component={ About } ></Route>
          <Route exact path={"/dashboard"} component={ Dashboard }></Route>
          <Route exact path={"/assets/images/carousel/login.jpg"} ></Route>
          <Route exact path={"/assets/images/carousel/dashbord.jpg"} ></Route>
          <Route exact path={"/assets/images/carousel/dashbord-chat.jpg"} ></Route>
          <Route exact path={"/assets/images/carousel/dashbord-tvpage.jpg"} ></Route>
          <Route exact path={"/assets/images/datatable/sort_asc.png"} ></Route>
          <Route exact path={"/assets/images/datatable/sort_asc_disabled.png"} ></Route>
          <Route exact path={"/assets/images/datatable/sort_both.png"} ></Route>
          <Route exact path={"/assets/images/datatable/sort_desc.png"} ></Route>
          <Route exact path={"/assets/images/datatable/sort_desc_disabled.png"} ></Route>
          <Route exact path={"/assets/images/carousel/app-desktop.png"} ></Route>
          <Route exact path={"/assets/apps/Setari-Sopcast.zip"} ></Route>
          <Route exact path={"/assets/apps/VbSopcast.zip"} ></Route>
          <Route path="/" component={ GenericNotFound } />
        </Switch>
      </div>
    </HashRouter>
    </div>
  );
  
  function Dashboard() {
    return (
      <div>
        <Header />
        <Bodyhead />
      </div>
    );
  }
}

function Logout() {
  localStorage.setItem('authlogin', 'false');
  window.location.href = "/reactsopcast/";
  return (<div></div>);
}

export default App;
